import { useDictionary, useItems } from "@adamlip/okeoke.client"
import { useEffect, useState } from "react"
import SizeGroup from "./SizeGroup"
import toast from "react-hot-toast"
import ListItemShell from "views/Order/ItemList/ListItemShell"

export default function MenuOptionsSelector({
  selectedSize,
  setSizeGroupsValidation,
  selectedAssembledItems,
  selectedAssembledItem,
  setSelectedAssembledItem,
}) {
  const { getValue } = useDictionary()
  const { sizeGroups, sizeConnections } = useItems()

  const [selectedSizeGroups, setSelectedSizeGroups] = useState([])

  const getSelectedMembers = (groupUUID) => {
    return selectedAssembledItems.current?.[groupUUID]
  }

  const handleSetMenuItem = (item) => {
    console.log(item)
    setSelectedAssembledItem(item)
  }

  const addSelectedItem = (assembledItem) => {
    const { minSelect, maxSelect } =
      sizeGroups?.[assembledItem?.sizeGroupUUID] || {}

    const { count: oldCount } = selectedAssembledItems.current?.[
      assembledItem.sizeGroupUUID
    ]?.[assembledItem.selectedSizeUUID] || { count: 0 }

    const { count: newCount } = assembledItem

    let groupTotalCount = Object.values(
      selectedAssembledItems.current?.[assembledItem.sizeGroupUUID] || {}
    ).reduce((acc, curr) => acc + (curr?.count || 0), 0)

    if (minSelect === 1 && maxSelect === 1) {
      if (assembledItem?.count < 1) {
        toast.error(getValue("app_v2_menu_cant_remove"))
      } else {
        selectedAssembledItems.current = {
          ...selectedAssembledItems.current,
          [assembledItem.sizeGroupUUID]: {
            [assembledItem.selectedSizeUUID]: assembledItem,
          },
        }
      }
    } else {
      let canAdd = true
      if (
        newCount > oldCount &&
        maxSelect !== 0 &&
        groupTotalCount - oldCount + newCount > maxSelect
      ) {
        toast.error(getValue("app_v2_menu_cant_add_more"))
        canAdd = false
      }
      if (newCount < oldCount && minSelect !== 0 && groupTotalCount === 1) {
        toast.error(getValue("app_v2_menu_cant_remove"))
        canAdd = false
      }
      if (canAdd) {
        selectedAssembledItems.current = {
          ...selectedAssembledItems.current,
          [assembledItem.sizeGroupUUID]: {
            ...selectedAssembledItems.current[assembledItem.sizeGroupUUID],
            [assembledItem.selectedSizeUUID]: assembledItem,
          },
        }
      }
    }
  }

  useEffect(() => {
    if (selectedSize && sizeConnections) {
      if (sizeConnections?.[selectedSize?.uuid]?.g) {
        let groups = sizeConnections?.[selectedSize?.uuid]?.g
          ?.sort((a, b) => a.idx - b.idx)
          ?.map((group) => sizeGroups?.[group.uuid])
        setSelectedSizeGroups(groups)
      }
    }
  }, [selectedSize, sizeConnections, sizeGroups])

  return (
    <div className="flex flex-col h-full">
      <ListItemShell
        itemUUID={selectedSize.itemUUID}
        selectedSizeUUID={selectedSize.uuid}
        valid={selectedAssembledItem?.valid}
        disabled={selectedAssembledItem == null}
        menuItemParams={{
          onAdd: handleSetMenuItem,
          defaultCount: 1,
          minSelect: 1,
          maxSelect: 1,
          selectedSizeUUID: selectedSize.uuid,
          price: selectedSize.price,
          selected: selectedAssembledItem != null,
          hideCounter: true,
        }}
      />
      {selectedSizeGroups?.filter((group) => group.enabled)?.length < 1 && (
        <div className="">{getValue("app_v2_menu_no_available_groups")}</div>
      )}
      {selectedSizeGroups?.filter((group) => group.enabled)?.length > 0 && (
        <>
          <div className="overflow-auto">
            {selectedSizeGroups
              ?.filter((group) => group.enabled)
              ?.map((group) => (
                <SizeGroup
                  key={group.uuid}
                  group={group}
                  setSizeGroupsValidation={setSizeGroupsValidation}
                  addSelectedItem={addSelectedItem}
                  getSelectedMembers={getSelectedMembers}
                />
              ))}
          </div>
        </>
      )}
    </div>
  )
}
